// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3lzZy","insightsList":"newBusinessInsightsMenu_insightsList__2K_Sk","active":"newBusinessInsightsMenu_active__3e6WK"};